import { render, staticRenderFns } from "./PlatformIcon.vue?vue&type=template&id=6ecfccd2"
import script from "./PlatformIcon.vue?vue&type=script&lang=js"
export * from "./PlatformIcon.vue?vue&type=script&lang=js"
import style0 from "./PlatformIcon.vue?vue&type=style&index=0&id=6ecfccd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports